import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {VisitPlanAccountModel} from "../../../models/visit-plan-account.model";
import {VisitPlanCellModel} from "../../../models/visit-plan-cell.model";
import {VisitPlanSlotTrackerModel} from "../../../models/visit-plan-slot-tracker.model";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitPlanCallModel} from "../../../models/visit-plan-call.model";
import {RecurrencePatternModel} from "../../../models/recurrence-pattern.model";
import {VisitPlanAccountAnalysisModel} from "../../../models/visit-plan-account-analysis.model";
import {
  VisitPlanTrackerCallRecurringConfigurationOptionsModel
} from "../../../models/visit-plan-tracker-call-recurring-configuration-options.model";

export const VisitPlanAccountChannelActions = createActionGroup({
  source: '[VisitPlanAccount/Channel]',
  events: {
    subscribe: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: VisitPlanCellModel }>()
  }
});

export const VisitPlanAccountAPiActions = createActionGroup({
  source: '[VisitPlanAccount/API]',
  events: {

    //Get Visit Plan Accounts
    getVisitPlanAccounts: props<{ visitPlanId: string, params?: any }>(),
    getVisitPlanAccountsSuccess: props<{
      visitPlanAccounts: VisitPlanAccountModel[],
      visitPlanId: string,
      cursor?: string
    }>(),
    getVisitPlanAccountsFailure: props<{ error: any }>(),

    //Get Visit Plan Accounts
    getVisitPlanAccountsAnalysis: props<{ visitPlanId: string, params?: any }>(),
    getVisitPlanAccountsAnalysisSuccess: props<{
      visitPlanAccountsAnalysis: VisitPlanAccountAnalysisModel[],
      cursor?: string
    }>(),
    getVisitPlanAccountsAnalysisFailure: props<{ error: any }>(),

    deleteCallsFromCell: props<{ visitPlanId: string, cellId: string, callIds: string[], deleteRecurringConfiguration?: boolean }>(),
    deleteCallsFromCellSuccess: props<{ visitPlanCell: VisitPlanCellModel }>(),
    deleteCallsFromCellFailure: props<{ error: any }>(),

    createCall: props<{ visitPlanId: string, cellId: string, call: VisitPlanCallModel, recurrencePattern?: RecurrencePatternModel }>(),
    createCallSuccess: props<{ visitPlanCell: VisitPlanCellModel }>(),
    createCallFailure: props<{ error: any }>(),

    updateCellTracker: props<{ visitPlanId: string, visitPlanCell: VisitPlanCellModel, callIdConfigurationUpdateOptions: Record<string, VisitPlanTrackerCallRecurringConfigurationOptionsModel> }>(),
    updateCellTrackerSuccess: props<{ visitPlanCellTracker: VisitPlanSlotTrackerModel }>(),
    updateCellTrackerFailure: props<{ error: any }>(),

    updateCallsTimeWindow: props<{
      visitPlanId: string,
      cellId: string,
      list: { callId: string, notBefore: number, notAfter: number }[]
    }>(),
    updateCallsTimeWindowSuccess: props<{ visitPlanCells: VisitPlanCellModel[] }>(),
    updateCallsTimeWindowFailure: props<{ error: any }>(),

    assignCallsToResource: props<{
      visitPlanId: string,
      visitScheduleId: string,
      resourceId: string,
      callIds: string[],
      cellId: string,
      accountId: string,
      dateRange: { from: number, to: number }
    }>(),
    assignCallsToResourceSuccess: props<{ visitPlanCell: VisitPlanCellModel }>(),
    assignCallsToResourceFailure: props<{ error: any, cellId: string, userMessage?: string }>(),

    submitVisitPlanTracker: props<{ visitPlanId: string, includeIds?: string[], excludeIds?: string[] }>(),
    submitVisitPlanTrackerSuccess: props<{ visitPlan: VisitPlanModel, includeIds?: string[], excludeIds?: string[] }>(),
    submitVisitPlanTrackerFailure: props<{ error: any }>(),

    discardChanges: props<{ visitPlanId: string, includeIds?: string[], excludeIds?: string[] }>(),
    discardChangesSuccess: props<{ includeIds?: string[], excludeIds?: string[] }>(),
    discardChangesFailure: props<{ error: any }>(),

    syncVisitPlan: props<{ visitPlanId: string, accountIds: string[] }>(),
    syncVisitPlanSuccess: props<{ visitPlan: VisitPlanModel }>(),
    syncVisitPlanFailure: props<{ error: any }>(),
  }
});

export const VisitPlanAccountActions = createActionGroup({
  source: '[VisitPlanAccount]',
  events: {
    removeAll: emptyProps(),
    clearStore: emptyProps(),
    clearCellTrackers: emptyProps()
  }
});


